/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-session-vitals.reducer';

export const TreatmentSessionVitalsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentSessionVitalsEntity = useAppSelector(state => state.treatmentSessionVitals.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentSessionVitalsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.detail.title">TreatmentSessionVitals</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.timestampEntry}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{treatmentSessionVitalsEntity.notes}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.vitals">Vitals</Translate>
          </dt>
          <dd>{treatmentSessionVitalsEntity.vitals ? treatmentSessionVitalsEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.recordingNurse">Recording Nurse</Translate>
          </dt>
          <dd>{treatmentSessionVitalsEntity.recordingNurse ? treatmentSessionVitalsEntity.recordingNurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.validatingNurse">Validating Nurse</Translate>
          </dt>
          <dd>{treatmentSessionVitalsEntity.validatingNurse ? treatmentSessionVitalsEntity.validatingNurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentSessionVitalsEntity.cycle ? treatmentSessionVitalsEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentSessionVitals.radiationSession">Radiation Session</Translate>
          </dt>
          <dd>{treatmentSessionVitalsEntity.radiationSession ? treatmentSessionVitalsEntity.radiationSession.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-session-vitals" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-session-vitals/${treatmentSessionVitalsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentSessionVitalsDetail;
